import React from "react";
import { useNavigate } from "react-router-dom";
import { FaGithub } from "react-icons/fa"; 
import { useLocalizedStrings } from "../Localization";  
import droneImage from "../assets/drone_project_poster.png";
import clothImage from "../assets/cloth_segmentation_project_poster.png";
import chatbotImage from "../assets/rasa-logo.png";

const Projects = () => {
  const strings = useLocalizedStrings();
  const navigate = useNavigate(); // Yönlendirme için hook

  const projects = [
    {
      name: strings.robustDrone,
      topic: strings.robustDroneDesc,
      image: droneImage,
      github: "https://github.com/oyelmali/AirSim-Project-with-DRL-algorithms",
      tags: ["AI", "Reinforcement Learning", "Deep Learning", "Unreal Engine 4", "AirSim"],
      routeName: "/project/drone"
    },
    {
      name: strings.semanticClothes,
      topic: strings.semanticClothesDesc,
      image: clothImage,
      github: "https://github.com/oyelmali/Cloth-Semantic-Segmentation",
      tags: ["PyTorch", "Python", "Deep Learning", "Segmentation", "Object Detection"],
      routeName: "/project/segmentation"
    },
    {
      name: strings.iso50001Chatbot,
      topic: strings.iso50001ChatbotDesc, 
      image: chatbotImage,
      github: "https://github.com/oyelmali/iso50001-chatbot", // GitHub repo URL'nizi buraya ekleyin
      tags: ["Rasa", "NLP", "Chatbot", "Docker", "Google Cloud Run", "React"],
      routeName: "/project/chatbot" // Chatbot sayfasına yönlendirme için route
    }
  ];

  return (
    <div className="flex justify-center mt-20 w-full">
      <div className="relative md:max-w-[80%] w-[90%] bg-[#FFDCCC] border-4 border-black rounded-xl shadow-lg md:p-10 p-3">
        <div 
          id="projects" 
          className="absolute -top-14 left-5 bg-black text-white px-4 py-2 text-4xl rounded-t-lg"
          style={{ fontFamily: 'Bokor' }}
        >
          {strings.myProjects}
        </div>

        <div className="flex flex-col items-center gap-10">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="flex flex-col md:flex-row items-center border-4 border-black rounded-xl shadow-lg bg-white w-full p-6 gap-6"
            >
              <img 
                src={project.image} 
                alt={project.name} 
                className="w-64 h-40 object-cover rounded-lg"
              />

              <div className="flex flex-col flex-1">
                <h2 className="text-2xl font-bold">{project.name}</h2>
                <p className="text-gray-700 mt-2">{project.topic}</p>

                <div className="flex items-center gap-4 mt-4">
                  <button 
                    className="px-4 py-2 bg-[#B7B1F2] text-black font-semibold border-2 border-transparent rounded-lg hover:bg-opacity-60 hover:border-black"
                    onClick={() => navigate(project.routeName)}
                  >
                    {strings.try}
                  </button>
                  <a 
                    href={project.github} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-2xl text-gray-900 hover:text-gray-700"
                  >
                    <FaGithub />
                  </a>
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  {project.tags.map((tag, i) => (
                    <span 
                      key={i}
                      className="px-3 py-1 text-sm bg-gray-200 rounded-full"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
